import { defineStore } from 'pinia'
import { ref } from 'vue'
import { data4seoService } from '../services/data4seo'

// Define supported languages with their names
const supportedLanguages = [
  { language_code: 'en', language_name: 'English' },
  { language_code: 'fr', language_name: 'Français' },
  { language_code: 'es', language_name: 'Español' },
  { language_code: 'de', language_name: 'Deutsch' },
  { language_code: 'it', language_name: 'Italiano' },
  { language_code: 'pt', language_name: 'Português' },
  { language_code: 'nl', language_name: 'Nederlands' },
  { language_code: 'pl', language_name: 'Polski' },
  { language_code: 'ru', language_name: 'Русский' },
  { language_code: 'ja', language_name: '日本語' },
  { language_code: 'ko', language_name: '한국어' },
  { language_code: 'zh', language_name: '中文' },
  { language_code: 'ar', language_name: 'العربية' },
  { language_code: 'hi', language_name: 'हिंदी' },
  { language_code: 'tr', language_name: 'Türkçe' },
  { language_code: 'vi', language_name: 'Tiếng Việt' }
]

export const useLanguageStore = defineStore('language', () => {
  const languages = ref(supportedLanguages)
  const selectedLanguage = ref(null)
  const loading = ref(false)
  const error = ref(null)

  async function fetchLanguages() {
    // Since we have predefined languages, we don't need to fetch from the API
    if (languages.value.length > 0) return

    loading.value = true
    error.value = null
    
    try {
      // Set default language to English if available
      const defaultLanguage = languages.value.find(lang => lang.language_code === 'en')
      if (defaultLanguage && !selectedLanguage.value) {
        selectedLanguage.value = defaultLanguage
      }
    } catch (err) {
      console.error('Error setting up languages:', err)
      error.value = err.message
    } finally {
      loading.value = false
    }
  }

  function setSelectedLanguage(language) {
    selectedLanguage.value = language
  }

  return {
    languages,
    selectedLanguage,
    loading,
    error,
    fetchLanguages,
    setSelectedLanguage
  }
}) 